(() => {
  "use strict";

  if (window.__CART_AUTO_OPEN_RUNNING__) return;
  window.__CART_AUTO_OPEN_RUNNING__ = true;

  const OPEN_DEBOUNCE_MS = 650;
  const AFTER_ADD_DELAY_MS = 120;

  let lastOpenAt = 0;
  let userClosedAt = 0;

  function now() { return Date.now(); }

  function canOpen() {
    const t = now();
    if (t - lastOpenAt < OPEN_DEBOUNCE_MS) return false;
    if (t - userClosedAt < 900) return false;
    lastOpenAt = t;
    return true;
  }

  function findDrawer() {
    return (
      document.querySelector("cart-drawer-component") ||
      document.querySelector("[data-cart-drawer] cart-drawer-component") ||
      document.querySelector("#CartDrawer cart-drawer-component") ||
      document.querySelector("#CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      null
    );
  }

  function openDrawer() {
    const drawer = findDrawer();
    if (!drawer) return;

    if (typeof drawer.open === "function") {
      drawer.open();
      return;
    }

    if (typeof drawer.showDialog === "function") {
      drawer.showDialog();
      return;
    }

    const dlg =
      (drawer instanceof HTMLDialogElement ? drawer : null) ||
      drawer.querySelector?.("dialog") ||
      null;

    if (dlg && typeof dlg.showModal === "function") {
      try { dlg.showModal(); } catch { try { dlg.setAttribute("open", ""); } catch {} }
      return;
    }

    const cartBtn =
      document.querySelector('[aria-controls*="cart"]') ||
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector(".header__icon--cart") ||
      document.querySelector('a[href="/cart"]') ||
      null;

    if (cartBtn && typeof cartBtn.click === "function") cartBtn.click();
  }

  function tryOpen() {
    if (!canOpen()) return;
    openDrawer();
  }

  function isOrderbumpRequest(url, init) {
    try {
      if (!url || !String(url).includes("/cart/add")) return false;
      const body = init && init.body ? String(init.body) : "";
      if (!body) return false;
      return body.includes('"properties"') && (body.includes('"_ob01"') || body.includes('"__ob01"'));
    } catch {
      return false;
    }
  }

  function attachAddListeners() {
    const events = ["cart:add", "cart:added", "product:added", "CartAddEvent"];
    events.forEach((name) => {
      document.addEventListener(name, () => {
        setTimeout(tryOpen, AFTER_ADD_DELAY_MS);
      });
    });
  }

  function attachFormListener() {
    document.addEventListener(
      "submit",
      (ev) => {
        const form = ev.target;
        if (!(form instanceof HTMLFormElement)) return;
        const action = (form.getAttribute("action") || "").toLowerCase();
        if (!action.includes("/cart/add")) return;
        setTimeout(tryOpen, AFTER_ADD_DELAY_MS);
      },
      true
    );
  }

  function attachFetchInterceptor() {
    if (!window.fetch) return;

    const origFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      const res = await origFetch(...args);

      try {
        const input = args[0];
        const init = args[1] || {};
        const url =
          typeof input === "string"
            ? input
            : input && typeof input.url === "string"
              ? input.url
              : "";

        if (url.includes("/cart/add") && res && res.ok) {
          if (!isOrderbumpRequest(url, init)) {
            setTimeout(tryOpen, AFTER_ADD_DELAY_MS);
          }
        }
      } catch {}

      return res;
    };
  }

  function attachUserCloseDetection() {
    document.addEventListener(
      "click",
      (ev) => {
        const t = ev.target;
        if (!t) return;
        const closeBtn =
          t.closest?.('[aria-label*="close" i]') ||
          t.closest?.('[data-close]') ||
          t.closest?.(".menu-drawer__close-button");
        if (closeBtn) userClosedAt = now();
      },
      true
    );
  }

  function boot() {
    attachAddListeners();
    attachFormListener();
    attachFetchInterceptor();
    attachUserCloseDetection();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
